import { cloudflareImage } from "../utils/utils";

export function makeReviewSchema({ game, review, url }) {
  const defaultDescription = review.title + (review.tagline ? " - " + review.tagline : "");
  const schema = {
    "@context": "http://schema.org",
    "@type": "VideoGame",
    operatingSystem: game.platforms.map(({ name }) => name),
    keywords: [game.name],
    name: game.name,
    audience: "everyone",
    url,
    image: `https://cdn.appcheeta.com/${review.image}`,
    thumbnailUrl: cloudflareImage(review.image, { width: 512, fit: "contain" }),
    applicationCategory: "GameApplication",
    description: review.meta_description || defaultDescription,
    datePublished: review.created,
    genre: game.categories.map(({ name }) => name),
    dateModified: review.modified,
    aggregateRating: {
      "@type": "AggregateRating",
      bestRating: 5,
      worstRating: 1,
      ratingValue: review.rating,
      reviewCount: 1,
    },
    author: {
      "@type": "Person",
      name: `${review.author.first_name} ${review.author.last_name}`,
    },
  };
  return schema;
}

export function makeArticleShema({ article, url }) {
  const defaultDescription = article.title + (article.tagline ? " - " + article.tagline : "");
  const schema = {
    "@context": "http://schema.org/",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url,
    },
    image: `https://cdn.appcheeta.com/${article.image}`,
    url,
    description: article.description || defaultDescription,
    "@type": "NewArticle",
    datePublished: article.created,
    headline: article.title + " -  AppCheeta",
    publisher: {
      "@type": "Organization",
      name: "AppCheeta",
      logo: {
        "@type": "ImageObject",
        url: "https://www.appcheeta.com/logo.png",
      },
    },
    author: {
      "@type": "Person",
      name: `${article.author.first_name} ${article.author.last_name}`,
    },
    dateModified: article.modified,
  };
  return schema;
}
